import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { BusinessTransportInsuranceMetadata } from 'src/app/_types/lead.types';
import {
  BusinessTransportPolicyType,
  getBusinessTransportPolicyTypeLabel,
} from 'src/app/enums/business/business-transport-policy-type.enum';
import { InsuranceType } from 'src/app/enums/insurance-type.enum';
import {
  BUSINESS_INSURANCE_PAYMENT_FREQUENCY,
  getPaymentFrequencyLabel,
} from 'src/app/enums/payment-frequency.enum';

import { LeadFormBase } from '../../lead-form-base';

@Component({
  selector: 'app-business-transport-form',
  templateUrl: './business-transport-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class BusinessTransportFormComponent
  extends LeadFormBase
  implements OnInit
{
  @Input()
  formGroup!: FormGroup;

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.BUSINESS_TRANSPORT,
    startDate: [null],
    contractDuration: [null],
    paymentFrequency: [null],
    splitPaymentFee: [null],
    policyType: [null],
    coverages: [null],
    limitations: [null],
    deductibleByCase: [null],

    insuranceSumByMeans: this.fb.group({
      insuranceSumRailroad: [null],
      insuranceSumTruck: [null],
      insuranceSumPlane: [null],
      insuranceSumBoat: [null],
    }),

    insuranceSumLocal: this.fb.group({
      insuranceSumParcelSignature: [null],
      insuranceSumRegistedLetter: [null],
      insuranceSumSecurePost: [null],
    }),

    insuranceSumInternational: this.fb.group({
      insuranceSumParcel: [null],
      insuranceSumRegistedLetter: [null],
    }),

    insuranceSumPostal: this.fb.group({
      insuranceSumParcel: [null],
      insuranceSumMerchandise: [null],
    }),
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) {
      this.metadataFormGroup.patchValue(this.metadata);
      const transportMetadata = this
        .metadata as BusinessTransportInsuranceMetadata;
      if (transportMetadata.insuranceSumByMeans) {
        this.metadataFormGroup.controls['insuranceSumByMeans'].patchValue(
          transportMetadata.insuranceSumByMeans
        );
      }
      if (transportMetadata.insuranceSumLocal) {
        this.metadataFormGroup.controls['insuranceSumLocal'].patchValue(
          transportMetadata.insuranceSumLocal
        );
      }
      if (transportMetadata.insuranceSumInternational) {
        this.metadataFormGroup.controls['insuranceSumInternational'].patchValue(
          transportMetadata.insuranceSumInternational
        );
      }
      if (transportMetadata.insuranceSumPostal) {
        this.metadataFormGroup.controls['insuranceSumPostal'].patchValue(
          transportMetadata.insuranceSumPostal
        );
      }
    }
    this.formGroup.addControl('metadata', this.metadataFormGroup);
  }

  paymentFrequencyValues = BUSINESS_INSURANCE_PAYMENT_FREQUENCY;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  policyTypeValues = Object.values(BusinessTransportPolicyType);

  getBusinessTransportPolicyTypeLabel = getBusinessTransportPolicyTypeLabel;
}
